export const ACTION_TYPES = {
  GET_SECTIONS_COUNT_REQUEST_SUCCESS: 'GET_SECTIONS_COUNT_REQUEST_SUCCESS',
  GET_SECTIONS_COUNT_REQUEST_ERROR: 'GET_SECTIONS_COUNT_REQUEST_ERROR',
  INITIALIZE_SECTION_QUERY_STATE: 'INITIALIZE_SECTION_QUERY_STATE',
  UPDATE_SECTION_QUERY_STATE: 'UPDATE_SECTION_QUERY_STATE',
  ADD_SECTION_REQUEST: 'ADD_SECTION_REQUEST',
  ADD_SECTION_REQUEST_SUCCESS: 'ADD_SECTION_REQUEST_SUCCESS',
  REMOVE_SECTION_SUCCESS: 'REMOVE_SECTION_SUCCESS',
  ADD_SECTION_TO_VIRTUAL_LIST_SUCCESS: 'ADD_SECTION_TO_VIRTUAL_LIST_SUCCESS',
};
